/**
 * 头部组件
 * 提供应用的顶部导航和品牌信息
 */

import React from 'react';
import { useTheme } from '../../design-system/hooks/useTheme.jsx';
import Navigation from './Navigation.jsx';

/**
 * 头部组件
 * @param {Object} props - 组件属性
 * @param {string} props.className - 自定义样式类
 */
function Header({ className = '' }) {
  const { currentTheme } = useTheme();

  return (
    <header className={`bg-card border-b border-border ${className}`}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* 品牌标识 */}
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
              <svg className="w-5 h-5 text-primary-foreground" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
              </svg>
            </div>
            <div>
              <h1 className="text-lg font-bold text-foreground">Liu Er Site</h1>
              <p className="text-xs text-muted-foreground">MVVM 架构演示</p>
            </div>
          </div>

          {/* 导航菜单 */}
          <Navigation />

          {/* 主题切换和用户信息 */}
          <div className="flex items-center space-x-4">
            {/* 主题指示器 */}
            <div className="flex items-center space-x-2 px-3 py-1 bg-muted rounded-full">
              <div className={`w-2 h-2 rounded-full ${
                currentTheme?.name === 'dark' ? 'bg-yellow-400' : 'bg-blue-500'
              }`}></div>
              <span className="text-xs text-muted-foreground capitalize">
                {currentTheme?.name || 'light'}
              </span>
            </div>

            {/* 用户头像 */}
            <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
              <svg className="w-4 h-4 text-primary-foreground" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;